import React from 'react';
import _get from 'lodash/get';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';

import FilterLayout from 'pages/Features/tabs/Directory/FilterLayout';
import * as Types from 'pages/Pages/typings';
import { Fields } from 'types/FormValue';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  values: Types.EntitySettingsFormValues;
  errors: any;
  userStatus: number;
  fields: Fields;
  onChange: (field: string, value: any) => void;
}

function SearchSettings({ setFieldValue, values, errors, userStatus, fields, onChange }: Props) {
  const classes = useStyles();
  const isSearchEnabled = _get(values, 'settings.directorySearch.enabled');
  const isDisplayedOnEmptySearch = _get(values, 'settings.directorySearch.displayOnEmptySearch');

  const toggleSearchEnabled = () => {
    onChange('settings.directorySearch.enabled', !isSearchEnabled);
  };

  const toggleDisplayOnEmptySearch = () => {
    onChange('settings.directorySearch.displayOnEmptySearch', !isDisplayedOnEmptySearch);
  };

  return (
    <Card>
      <CardHeader
        action={
          <Switch
            checked={isSearchEnabled}
            inputProps={{ 'aria-label': 'display in directory results setting switch' }}
            onChange={toggleSearchEnabled}
          />
        }
        title="Display in Directory Results"
        subheader="If turned on, pages of this type will appear in the Sift Directory page when a search
          is performed."
      />
      <Divider />
      <CardContent className={classes.contentContainer}>
        <>
          <Typography variant="h6">Display Full Page List</Typography>
          <div className={classes.content}>
            <Typography variant="subtitle2">
              If turned on, the full list of pages will appear to users when there is no search
              performed. If you would only like to display the list when a search is performed,
              switch this setting off.
            </Typography>

            <Switch
              id="display-when-no-search-performed"
              inputProps={{ 'aria-label': 'display when no search performed switch' }}
              onChange={toggleDisplayOnEmptySearch}
              checked={isDisplayedOnEmptySearch}
              disabled={!isSearchEnabled}
            />
          </div>
        </>
      </CardContent>
      <FilterLayout
        onChange={setFieldValue}
        userStatus={userStatus}
        fields={Object.values(fields)}
        values={values}
        className={classes.filterCard}
      />
    </Card>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  contentContainer: {
    paddingBottom: 0,
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filterCard: {
    boxShadow: 'none',
  },
}));

export default SearchSettings;
